<template>
  <v-fab-transition>
    <v-btn
      id="cart"
      fab
      dark
      large
      color="greenb"
      fixed
      right
      bottom
      :class="{ 'ma-6 mr-16': $vuetify.breakpoint.mdAndUp }"
      v-if="this.$store.state.cart.length"
      @click="navigateToCart"
    >
      <v-badge color="blue darken-4" :content="total">
        <v-icon dark>mdi-cart</v-icon>
      </v-badge>
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    navigateToCart(){
      this.$ga.event("Navigation", "Cart über FloatingCart", "Navigation zu Warenkorb über FloatingCart");
      this.$router.push({name: 'Cart'});
    }
  },
  computed: {
    total() {
      return this.$store.state.cart.reduce(
        (acc, product) => acc + product.quantity,
        0
      );
      // return this.$store.state.cart.reduce((acc, product) => acc + product.itemId.price, 0);
    }
  },
  created() {
    // console.log(this.$store.state.cart);
  }
};
</script>
